import axios from "axios";
import Cookies from "universal-cookie";
const apiUrl = process.env.REACT_APP_API_URL;

const cookies = new Cookies();

export const addExpenseApi = async (
  Mode: string,
  From: string,
  Type: String,
  Purpose: String,
  DonationType: String | null,
  Amount: number,
  ExpenseOn: string,
  Desc: string,
  url: string,
  bankStatementId: string
): Promise<any> => {
  const token = cookies.get("authToken");
  try {
    const response = await axios.post(
      `${url}/expense/create`,
      {
        Mode,
        From,
        Type,
        DonationPurposeId: Purpose,
        DonationTypeId: DonationType,
        Amount,
        ExpenseOn,
        Desc,
        bankStatementId,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("API Error:", error);
    throw error;
  }
};

export const getExpenseApi = async (
  url: string,
  {
    year = "",
    month = "",
    searchTerm = "",
    pageNumber = 1,
    pageSize = 10,
    donationTypeId = "",
    donationPurposeId = "",
    mode = "",
    expenseCategoryIds
  }: {
    year?: string;
    month?: string;
    searchTerm?: string;
    pageNumber?: number;
    pageSize?: number;
    donationTypeId?: string;
    donationPurposeId?: string;
    mode?: string;
    expenseCategoryIds?: string[];
  } = {}
): Promise<any> => {
  const token = cookies.get("authToken");
  try {
    const response = await axios.get(`${url}/expense/get`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: {
        year,
        month,
        searchTerm,
        pageNumber,
        pageSize,
        donationTypeId,
        donationPurposeId,
        mode,
        expenseCategoryIds: expenseCategoryIds ? expenseCategoryIds.join(',') : undefined,
      },
    });
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const updateExpenseApi = async (
  Id: string,
  Mode: string,
  From: string,
  Purpose: String,
  DonationType: string | null,
  Amount: number,
  Type: string,
  ExpenseOn: string,
  Desc: string,
  url: string
) => {
  const token = cookies.get("authToken");
  try {
    const response = await axios.post(
      `${url}/expense/update`,
      {
        Id,
        Mode,
        From,
        DonationPurposeId: Purpose,
        DonationTypeId: DonationType,
        Amount,
        Type,
        ExpenseOn,
        Desc,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("API Error:", error);
    throw error;
  }
};

export const getExpenseByIdApi = async (url: string, id: string) => {
  const token = cookies.get("authToken");
  try {
    const response = await axios.get(`${url}/expense/GetByExpenseId`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: {
        Id: id,
      },
    });
    return response.data;
  } catch (error) {
    console.error(error);
    return false;
  }
};

export const updateExpenseBankStatementId = async (
  selectedExpenseIds: string[],
  bankstatementId: string
) => {
  const token = cookies.get("authToken");
  try {
    const response = await axios.patch(
      `${apiUrl}/expense/updateBankstatementId`,
      {
        expenseIds: selectedExpenseIds,
        bankStatementId: bankstatementId,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getAssingedExpenses = async (Id: string): Promise<any> => {
  const token = cookies.get("authToken");
  try {
    const response = await axios.get(
      `${apiUrl}/expense/getassignedexpenses/${Id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const UnAssignBSIdExpense = async (Id: string) => {
  const token = cookies.get("authToken");
  try {
    const response = await axios.post(
      `${apiUrl}/expense/unAssignBankstatementId/${Id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    console.log("response", response.data);
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
